var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1399_14352)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.25 60C50.1312 55.9829 47.66 52.4349 44.2249 49.9038C40.7898 47.3726 36.5801 46 32.25 46C27.9199 46 23.7102 47.3726 20.2751 49.9038C16.84 52.4349 14.3688 55.9829 13.25 60",
    stroke: "#050505",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2503 39.9997C37.405 39.9997 41.5837 35.821 41.5837 30.6663C41.5837 25.5117 37.405 21.333 32.2503 21.333C27.0957 21.333 22.917 25.5117 22.917 30.6663C22.917 35.821 27.0957 39.9997 32.2503 39.9997Z",
    stroke: "#050505",
    strokeLinecap: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#CBCBCB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1399_14352"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNew);
export default __webpack_public_path__ + "static/media/profile-new.9b29b94ee9dbdc6fc944bda3db07179d.svg";
export { ForwardRef as ReactComponent };